import { AuthContext, StaffRole } from '@urbanx/agx.auth.client'
import { useCallback, useContext } from 'react'

export const useDoesUserHasRequiredRoles = (): ((
  requiredRoles: StaffRole[] | undefined
) => boolean) => {
  const { userAccount } = useContext(AuthContext)

  const doesUserHaveRequiredRoles = useCallback(
    (requiredRoles: StaffRole[] | undefined) => {
      if (!requiredRoles || requiredRoles.length === 0) return true
      if (!userAccount) return false

      return requiredRoles.some((requiredRole) =>
        userAccount.roles?.includes(requiredRole)
      )
    },
    [userAccount]
  )

  return doesUserHaveRequiredRoles
}
